export enum InfluencerType {
  basic = 0,
  premium = 1,
  elite = 2,
}
